export class Page {
    uri: string;
    domain: string;
    title: string;
    query: string;
}
